import { render, staticRenderFns } from "./DiscussionCard.vue?vue&type=template&id=4cfc4b7b&scoped=true&"
import script from "./DiscussionCard.vue?vue&type=script&lang=js&"
export * from "./DiscussionCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionCard.vue?vue&type=style&index=0&id=4cfc4b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc4b7b",
  null
  
)

export default component.exports